import React, { useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'

// Styles
const CONTAINER_STYLES = 'flex flex-col w-full mt-1 mr-0 mb-3 ml-0'

const COLLAPSABLE_STYLES =
  'flex flex-row flex-grow flex-shrink-0 py-2 px-3 border-none rounded text-white bg-secondary'

const LABEL_STYLES =
  'text-white text-sm text-left font-heading font-bold uppercase my-auto mx-0 flex-auto'

const INDICATOR_STYLES =
  'text-white text-base my-auto mr-0 ml-2 items-center'
const INDICATOR_INLINE_STYLES = { flex: '0 0 auto' }

export interface ICollapseProps {
  label: string
  initiallyOpen?: boolean
  children: JSX.Element | JSX.Element[]
}

export const Collapse: React.FC<ICollapseProps> = (props) => {
  const [isOpen, setOpen] = useState(props.initiallyOpen || false)
  const handleClick = (e: React.MouseEvent) => {
    setOpen(!isOpen)
    e.preventDefault()
    e.stopPropagation()
  }
  return (
    <div className={CONTAINER_STYLES}>
      <button className={COLLAPSABLE_STYLES} onClick={handleClick}>
        <h3 className={LABEL_STYLES}>{props.label}</h3>
        <div style={INDICATOR_INLINE_STYLES} className={INDICATOR_STYLES}>
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
        </div>
      </button>
      {isOpen ? props.children : null}
    </div>
  )
}

Collapse.displayName = 'Content.Collapse'
